var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('span',{staticClass:"app-version",attrs:{"data-test-id":"text-app-version"}},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }